import { IconButton } from '@mui/material'
import React from 'react'
import Overflow from '../Overflow/Overflow'
import classes from './Modal.module.css'
import { AiOutlineClose } from 'react-icons/ai';
import { cx } from '../../../Utils/classnames';

const Modal = (props) => {
    const { children, title, onClose, className } = props

    return (
        <Overflow>
            <div className={cx(classes.main, className)}>
                <div className={classes.header}>
                    {title && <h2>{title}</h2>}
                    {onClose && <IconButton onClick={onClose}>
                        <AiOutlineClose/>
                    </IconButton>}
                </div>
                <div className={classes.body}>
                    {children}
                </div>
            </div>
        </Overflow>
    )
}

export default Modal